import BaseWebView from './base_web_view';
import {WEB_VIEW_IDS, WEB_VIEW_INFO, WEB_VIEW_REASON} from './web_view_manager_consts';
import {KEY_NAME} from '../../native/native_const';

class MasterWebView extends BaseWebView {

    static CLASS = 'MasterWebView';


    /**
     * isValidId
     * return return true if the id of master is correct
     */
    isValidId() {
        return WEB_VIEW_IDS.MASTER_ID === this._id;
    }

    /**
     * onHybridCall - call from hybrid
     * data example: {hybridcbfeaturefunc: "WebViewManagerFeature", webid: "0", action: "https://www.google.co.il/"}
     */
    onHybridCall(data) {

        let reason = this._getReason(data);

        switch (reason) {
            case WEB_VIEW_REASON.WEB_SECOND_NOT_SUPPORTED:
                this._disableSecondWebView();
                break;
            default:
                this.checkOpenLinks(data);
        }

    }

    /**
     * get Reason - get the currect reason of incoming msg
     * data example: websecondnotsupported
     */
    _getReason(data) {

        let val = data[KEY_NAME.ACTION];

        let reasonID = WEB_VIEW_REASON.OPEN_LINK;

        switch (val) {
            case WEB_VIEW_INFO.WEB_SECOND_NOT_SUPPORTED:
                reasonID = WEB_VIEW_REASON.WEB_SECOND_NOT_SUPPORTED;
                break;
            default:
                // maybe should throw an Exception here
                break;
        }

        return reasonID;
    }

    _disableSecondWebView() {
       this._parent.setFeatureGameDisable();
    }

}

export default MasterWebView;